import React from 'react';
import { DateDisplay, SanitizedHTML } from 'components/layout';
import { useQuery } from '@apollo/client';
import { List, Card, Descriptions, Divider } from 'antd';
import fp from 'lodash/fp';
import { GET_PROJECT_APPLICATION_SETTINGS } from 'gql/projectApplicationSetting';
import './style.less';
import ApplyButton from './components/ApplyButton';

const sortData = fp.sortBy(['showPriority', 'startDate']);

const NewProjectApplications = () => {
  const { data, loading } = useQuery(GET_PROJECT_APPLICATION_SETTINGS, {
    variables: {
      state: 'ACTIVE',
    },
  });
  const dataSource = sortData(data?.projectApplicationSettings);

  if (loading) {
    return (
      <List
        dataSource={[1, 2]}
        renderItem={() => (
          <List.Item>
            <Card loading style={{ width: '100%' }} />
          </List.Item>
        )}
      ></List>
    );
  }

  return (
    <List
      dataSource={dataSource}
      pagination={{
        hideOnSinglePage: true,
        pageSize: 20,
      }}
      renderItem={(projectApplicationSetting) => (
        <List.Item>
          <Card
            key={projectApplicationSetting.id}
            title={
              <div
                style={{
                  whiteSpace: 'break-spaces',
                }}
              >
                {projectApplicationSetting.title}
              </div>
            }
            hoverable
          >
            <Descriptions column={1}>
              <Descriptions.Item label="Application Period">
                <DateDisplay date={projectApplicationSetting?.startDate} />
                {` - `}
                <DateDisplay date={projectApplicationSetting?.endDate} />
              </Descriptions.Item>
              <Descriptions.Item
                label="Deadline for Using Allocated Funds"
                style={{ paddingBottom: 0 }}
              >
                <DateDisplay
                  date={projectApplicationSetting?.deadlineOfUsingUpFunding}
                />
              </Descriptions.Item>
            </Descriptions>
            <Divider style={{ margin: '16px 0' }} />
            <Descriptions column={1}>
              <Descriptions.Item>
                <SanitizedHTML dirty={projectApplicationSetting.description} />
                <ApplyButton
                  id={projectApplicationSetting.id}
                  showPriority={projectApplicationSetting.showPriority}
                  startDate={projectApplicationSetting.startDate}
                />
              </Descriptions.Item>
            </Descriptions>
          </Card>
        </List.Item>
      )}
    ></List>
  );
};

export default NewProjectApplications;
